import React from 'react'
import LandingPage from './components/LandingPage'

const App = () => {
  return (
    <div>
      <LandingPage/>
    </div>
  )
}

export default App
